import { ReportType, ReportConfig } from "@administrationReports/models/reportAvailability.models";
import {
  DOCUMENT_REPORT,
  WHO_ACCESSED_DOCUMENTS_REPORT,
  TERMS_ACCEPTANCE_REPORT,
  WHO_ACCESSED_DATA_ROOMS_REPORT,
  WHO_ACCESSED_EVENT_REPLAYS_REPORT,
  WHO_ACCESSED_FEATURED_INSIGHTS_REPORT,
  BOUNCE_BACK_REPORT,
} from "./administrationReportsOptions";

// Maps each report to its API endpoint for checking data availability
export const REPORT_CONFIG: Record<ReportType, ReportConfig> = {
  [ReportType.WHO_ACCESSED_DOCUMENTS_REPORT]: {
    service: "documents",
    endpoint: "/documents/v1/reports/availability",
  },
  [ReportType.DOCUMENT_REPORT]: {
    service: "documents",
    endpoint: "/documents/v1/reports/availability",
  },
  [ReportType.WHO_ACCESSED_DATA_ROOMS_REPORT]: {
    service: "documents",
    endpoint: "/documents/v1/reports/availability",
  },
  [ReportType.WHO_ACCESSED_EVENT_REPLAYS_REPORT]: {
    service: "documents",
    endpoint: "/documents/v1/reports/availability",
  },
  [ReportType.WHO_ACCESSED_FEATURED_INSIGHTS_REPORT]: {
    service: "documents",
    endpoint: "/documents/v1/reports/availability",
  },
  [ReportType.BOUNCE_BACK_REPORT]: {
    service: "documents",
    endpoint: "/documents/v1/reports/availability",
  },
  [ReportType.TERMS_ACCEPTANCE_REPORT]: {
    service: "entitlements",
    endpoint: "/entitlements/v1/user/Terms/ReportAvailability",
  },
};

// Maps dropdown report IDs to API report types
export const REPORT_ID_TO_TYPE_MAP: Record<string, ReportType | null> = {
  [WHO_ACCESSED_DOCUMENTS_REPORT]: ReportType.WHO_ACCESSED_DOCUMENTS_REPORT,
  [DOCUMENT_REPORT]: ReportType.DOCUMENT_REPORT,
  [TERMS_ACCEPTANCE_REPORT]: ReportType.TERMS_ACCEPTANCE_REPORT,
  [WHO_ACCESSED_DATA_ROOMS_REPORT]: ReportType.WHO_ACCESSED_DATA_ROOMS_REPORT,
  [WHO_ACCESSED_EVENT_REPLAYS_REPORT]: ReportType.WHO_ACCESSED_EVENT_REPLAYS_REPORT,
  [WHO_ACCESSED_FEATURED_INSIGHTS_REPORT]: ReportType.WHO_ACCESSED_FEATURED_INSIGHTS_REPORT,
  [BOUNCE_BACK_REPORT]: ReportType.BOUNCE_BACK_REPORT,
  DOCUMENTS_MISSING_ENTITLEMENTS: null,
  DOCUMENTS_DIGEST_DISPATCH_REPORT: null,
};
